import React from 'react';
import {
  DefiReglementDynamicZone,
  ComponentDefiReglement
} from 'graphql/generated/graphql';
import useStyle from './challengeRules.style';

interface ChallengeRulesProps {
  rules: DefiReglementDynamicZone[];
}

export const ChallengeRules = ({ rules }: ChallengeRulesProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      {rules.map((rule: ComponentDefiReglement, index) => (
        <div key={index}>
          {rule.title && <p className={classes.title}>{rule.title}</p>}
          {rule.text && <p>{rule.text}</p>}
        </div>
      ))}
    </div>
  );
};
